import { Vue, Component } from 'vue-property-decorator';
import '@/registerVuePlugins';

import { default as TaskTypesPage } from './Components/TaskTypesPage.vue';

@Component({
  name: 'task-types-component',
  components: { TaskTypesPage }
})
class TaskTypesComponent extends Vue {
  public verificationToken: string = '';

  public async mounted() {
    this.verificationToken = await this.$verificationToken();
  }
}

new TaskTypesComponent()
  .$mount('#task-types-view');